import React from "react";
import { useTranslation } from "react-i18next";
import "./index.less";
import { slimImage } from "@/service/utils";
import Button from "../dc-button";
import { useObserver } from "mobx-react-lite";
import { useStores } from "@/store";
import { getQuery } from "@/service/http";
const { lang = "en" } = getQuery();

/**
 * 餐厅信息
 *
 * @returns
 */
const Restaurant = ({ events }) => {
  const { t } = useTranslation();

  /**查看餐厅详情 */
  function onRestaurantClick(item) {
    window.open(item.detail_in_events_url, "_blank");
  }
  if (!events.length) return null;
  return useObserver(() => {
    const { currency } = restaurantStore;
    return (
      <div className="dc-special-events">
        <h3>{t("WEB.Special event menu")}</h3>
        {events.map((item) => {
          return (
            <article
              key={item.id}
              className="dc-special-event"
              onClick={() => onRestaurantClick(item)}
            >
              <Button type="primary">{t("WEB.event get")}</Button>
              <div className="dc-special-event--image">
                <img
                  src={slimImage(item.restaurant_profile_cover)}
                  width="106"
                  height="80"
                />
              </div>
              <div className="dc-special-event--content">
                <div className="dc-special-event--name">{item.title}</div>
                {lang === "en" ? (
                  <div className="dc-special-event--price">
                    From{" "}
                    <em>
                      {currency}
                      {item.price}
                    </em>
                  </div>
                ) : (
                  <div className="dc-special-event--price">
                    <em>
                      {currency}
                      {item.price}
                    </em>{" "}
                    起
                  </div>
                )}
                {lang === "en" ? (
                  <div className="dc-special-event--left">
                    Only <span>{item.days_left}</span> days left
                  </div>
                ) : (
                  <div className="dc-special-event--left">
                    只剩 <span>{item.days_left}</span> 天
                  </div>
                )}
              </div>
            </article>
          );
        })}
      </div>
    );
  });
};

export default Restaurant;
